import { EventRecurrenceDto, RecurrenceType } from 'api/dtos/event';
import { combineDateAndTime } from 'utils/timeDateUtils';

export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;

export const getAvailableWeekdays = (recurrence?: EventRecurrenceDto): number[] => {
    if (recurrence?.type !== RecurrenceType.Daily) {
        return [];
    }

    const excludedDays = recurrence.daily?.excludedDays ?? [];

    return WEEKDAYS.filter((day) => !excludedDays.includes(day));
};

export const sanitizeSelectedWeekdays = (
    selectedWeekdays: number[],
    recurrence?: EventRecurrenceDto,
): number[] => {
    const availableWeekdays = new Set(getAvailableWeekdays(recurrence));

    return [...new Set(selectedWeekdays)]
        .filter((day) => availableWeekdays.has(day))
        .sort((a, b) => a - b);
};

export const getSelectedWeekdaysDateRange = (
    occurrenceDate: string,
    editedDateFrom: string,
    editedDateTo: string,
    timeFrom: string,
    timeTo: string,
    isMultiDay: boolean,
) => {
    const editedStart = combineDateAndTime(editedDateFrom, timeFrom);
    const editedEnd = combineDateAndTime(isMultiDay ? editedDateTo : editedDateFrom, timeTo);
    const pinnedStart = combineDateAndTime(occurrenceDate, timeFrom);
    const pinnedEnd = pinnedStart && editedStart && editedEnd
        ? pinnedStart.clone().add(editedEnd.diff(editedStart))
        : editedEnd;

    return { dateFrom: pinnedStart, dateTo: pinnedEnd };
};
